module.exports = __webpack_public_path__ + "img/CMS_Logo.312a6981.png";